import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { v4 as uuid } from "uuid";

import { EQEnrichedCourseSections } from "services/shortAnswerService/question-types/QuestionCourseSections";

import { getEQEnrichedCourseSectionsQueryOptions } from "features/teachers/service/queries";

type Args = {
  hardQuestionsEnabled?: boolean;
  courseId?: string | null;
  sectionId?: string;
  assignmentId?: string | null;
};

type QueryOptions = {
  enabled?: boolean;
  select?: (
    data: EQEnrichedCourseSections[]
  ) => EQEnrichedCourseSections[] | undefined;
};

export default function useEQEnrichedCourseSections(
  { hardQuestionsEnabled = true, courseId, sectionId, assignmentId }: Args,
  { select, enabled }: QueryOptions = {}
) {
  const [staticGenerationSeed] = useState<string>(uuid);

  const queryOptions = useMemo(
    () =>
      getEQEnrichedCourseSectionsQueryOptions(
        { hardQuestionsEnabled, sectionId, courseId, assignmentId },
        { select, enabled },
        staticGenerationSeed
      ),
    [
      hardQuestionsEnabled,
      assignmentId,
      select,
      courseId,
      sectionId,
      enabled,
      staticGenerationSeed
    ]
  );

  return useQuery(queryOptions);
}
